import * as React from "react";
import FtEquityForm from "./ftPayInForm/ftEquityForm";
import { parsedToken } from "../../../service/storageHelper";
import { ACommFundLimit, AEqMaxPayout } from "../../../service/fundTransfer/fundTransferApiService";
import DeviceContext from "../../../service/indentifyDevice";
import { IftPayInBankListDetails, IcommLimits } from "../../../types/components/fundTransfer/ftTypes";
import { jwtToken, IListObj } from "../../../types/genericTypes";
import { FtPayInCashHeader } from "./ftPayInCashHeader";
import RadioButton from "../../../generic/radioButton";
import "../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFund.scss";
import { Idevice } from "../../../types/device";
import { useQuery } from "../../../service/urlHelper";

const hndlDevice: Idevice = DeviceContext();
if (hndlDevice.isDesktop) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundDesk.scss");
} else if (hndlDevice.isMobile) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundMob.scss");
} else {
	require("../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundTab.scss");
}

export interface IFtPayInFormWrapperProps {
	data?: IftPayInBankListDetails;
	commPayInURL?: string;
	maintenanceNode?: React.ReactNode;
}

export function FtPayInFormWrapper(props: IFtPayInFormWrapperProps) {
	const pToken: jwtToken | null = parsedToken();
	const queryAsset = useQuery().get("asset");
	let defaultAssetSel: string = pToken ? (pToken.accType === "COMEQ" ? "EQ" : pToken.accType) : "EQ";

	if (pToken?.accType === "COMEQ") {
		if (queryAsset && (queryAsset.toUpperCase() === "EQ" || queryAsset.toUpperCase() === "CO")) {
			defaultAssetSel = queryAsset.toUpperCase();
		}
	}

	//Cash available in EQ or CO or Both
	// for equity max payout api will be used
	//for comm account limits APi data will be used

	const [eqUserLim, setEqUserLim] = React.useState<string>("");
	const [coUserLim, setCoUserLim] = React.useState<IcommLimits>({
		colVal: "",
		lmAvl: "",
		lrB: "",
		mrUzd: "",
		piAmt: "",
		poAmt: ""
	});

	const assetList: Array<IListObj> = [
		{ value: "EQ", display: "Equity" },
		{ value: "CO", display: "Commodity" }
	];

	const eqMaxPayout = (res: any) => {
		if (res.data) {
			// setState({ eqCash: res.data.cshAvl });
			setEqUserLim(res.data.maxPytAmt);
		}
	};
	const commFundLimitRes = (res: any) => {
		if (res.data) {
			// setState({ commCash: res.data.lmt.lmAvl });
			setCoUserLim(res.data.lmt);
		}
	};

	const getFundLimit = () => {
		//both the API's will be called for COMMEQ Account
		if (pToken && pToken.accType !== "EQ") {
			ACommFundLimit(commFundLimitRes);
		}
		if (pToken && pToken.accType !== "CO") {
			AEqMaxPayout(eqMaxPayout);
		}
	};
	function init() {
		getFundLimit();
		return defaultAssetSel;
	}

	function reducer(_prevState: any, newState: any) {
		return newState;
	}
	//selected asset either EQ or CO

	const [asset, setAsset] = React.useReducer(reducer, defaultAssetSel, init);

	return (
		<>
			<div className="ft_add_fund">
				<FtPayInCashHeader eqCash={eqUserLim} coCash={coUserLim} />

				{/* <form noValidate autoComplete="off"> */}
				{pToken && pToken.accType === "COMEQ" && (
					<div className="form-field asset_radio_section pd-b40">
						<label className="input-label">Select Asset</label>
						<ul className="radio_wrap ledger_radio">
							{assetList.map((item) => (
								<li key={item.value} className="list_Item">
									<RadioButton
										list={{
											value: item.value,
											display: item.display
										}}
										name={"cvtPosition"}
										selected={asset}
										onChange={() => setAsset(item.value as string)}
										moduleName="fundTransfer"
									/>
								</li>
							))}
						</ul>
					</div>
				)}

				{pToken && props.data && (pToken.accType === "EQ" || asset === "EQ") && (
					// Show equity form if
					// either account type is EQ or
					// account type if COMEQ and Equity is selected
					<>{props.maintenanceNode ? props.maintenanceNode : <FtEquityForm data={props.data} totalLim={eqUserLim} />}</>
				)}
				{pToken && props.commPayInURL && (pToken.accType === "CO" || asset === "CO") && (
					// Show commodity form if
					// either account type is CO or
					// account type if COMEQ and Commodity is selected
					<div className="comm_form_wrap">
						<div className="comm_form_con">
							<a className="fund_pro_btn" rel="noreferrer" href={props.commPayInURL} target="_blank">
								Proceed to Fund Transfer <i className="edel-icon-arrow-right fr_arrow_right"></i>
							</a>
						</div>
					</div>
				)}
				{/* </form> */}
			</div>
		</>
	);
}

export default FtPayInFormWrapper;
